import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { LocationOptionList } from '../location_option_list';
import { getLabelText } from '../utils';
import { webConferencingKinds as defaultWebConferencingKinds, nonWebConferencingKinds as defaultNonWebConferencingKinds } from './constants';
const styledBareButtonWrapperCss = "s19qntil";
const StyledBareButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledBareButtonWrapperCss, props.className)} />;
});
const styledBareButtonCss = "s1bhvjr5";
const StyledBareButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(styledBareButtonCss, props.className)} />);
const allOptionsWrapperCss = "ajstmrv";
const AllOptionsWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(allOptionsWrapperCss, props.className)} />;
});
const Label = ({
  icon,
  kind
}) => <div>
    {icon}
    <BodyText size="medium" as="div">{getLabelText(kind)}</BodyText>
  </div>;
export const SquareLocationButton = ({
  onClickAction,
  icon,
  kind
}) => <StyledBareButtonWrapper>
    <StyledBareButton aria-label={getLabelText(kind)} onClick={onClickAction}>
      <Label icon={icon} kind={kind} />
    </StyledBareButton>
  </StyledBareButtonWrapper>;
export const SquareAllOptionsButton = ({
  icon,
  kind,
  onSelect,
  webConferencingKinds = defaultWebConferencingKinds,
  nonWebConferencingKinds = defaultNonWebConferencingKinds
}) => {
  const [toggleAllOptionsDropdown, AllOptionsDropdown] = useDropdown();
  return <AllOptionsWrapper>
      <StyledBareButton aria-label={I18n.t('publisher.event_types.additional_options')} onClick={toggleAllOptionsDropdown}>
        <Label icon={icon} kind={kind} />
      </StyledBareButton>
      <AllOptionsDropdown>
        <LocationOptionList updateSelectedKind={onSelect} nonWebConferencingKinds={nonWebConferencingKinds} webConferencingKinds={webConferencingKinds} />
      </AllOptionsDropdown>
    </AllOptionsWrapper>;
};

require("./location_buttons_and_options.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./location_buttons_and_options.js");